import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  Relationship,
  RelationshipPayload,
} from "@project/types/relationship";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/relationships`;
const SILENT: RequestConfig = { showNotification: false };

class RelationshipService {
  listRelationshipsPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<Relationship>> => {
    return fetchListPage<Relationship>(`${BASE}/`, query);
  };

  getRelationship = async (id: number): Promise<Relationship | undefined> => {
    const data = await get<ApiItemResponse<Relationship> | Relationship>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  createRelationship = async (
    payload: RelationshipPayload
  ): Promise<Relationship | undefined> => {
    const data = await post<
      ApiItemResponse<Relationship> | Relationship,
      RelationshipPayload
    >(`${BASE}/`, payload, SILENT);
    return unwrapItem(data);
  };

  updateRelationship = async (
    id: number,
    payload: Partial<RelationshipPayload>
  ): Promise<Relationship | undefined> => {
    const data = await patch<
      ApiItemResponse<Relationship> | Relationship,
      Partial<RelationshipPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  deleteRelationship = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const relationshipService = new RelationshipService();
